import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { VAM_SERVICE } from '@eggplant/api-hosts'
import type { ReactElement } from 'react'

interface Props {
  suiteId: string
  localPath: string
  children?: (data: string) => ReactElement
}

const GetSuiteTextFileRequest = ({
  suiteId,
  localPath,
  children
}: Props) => {
  const url = `${VAM_SERVICE}/assets/${suiteId}/latest_version/files/${localPath}`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      responseType='text'
      url={url}
    />
  )
}

export default GetSuiteTextFileRequest
